import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify"; // Import toast and ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import Toastify styles
import axios from "axios"; // Import axios
import "./ExaminationStudentList.css"


const ExaminationStudentList = () => {
  const { exam_name, class_number } = useParams();

  const [students, setStudents] = useState([]);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/students/fetch/${class_number}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && Array.isArray(response.data)) {
          const sortedStudents = response.data.sort((a, b) =>
            a.student_name.localeCompare(b.student_name)
          );
          setStudents(sortedStudents); // Set students data from backend
          if (response.data.length === 0) {
            toast.info("No students found for this class.");
          }
        }
      } catch (error) {
        toast.error("Error fetching student data");
      } finally {
        // Set loading to false after request completes
      }
    };

    if (class_number) {
      fetchStudents();
    }
  }, [class_number]);

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link
              to={`/erp/examinations/${exam_name}`}
              className="btn btn-secondary mb-3"
            >
              &#8592; Select Class
            </Link>
            <h3 className="text-center text-success">
              Student List of Class {class_number}
            </h3>
          </div>
          <div className="text-center d-flex justify-content-end">
            <h5>
              Exam -
              {exam_name === "unit-test-1"
                ? "Unit Test 1"
                : exam_name === "terminal-1"
                ? "Terminal 1"
                : exam_name === "unit-test-2"
                ? "Unit Test 2"
                : exam_name === "terminal-2"
                ? "Terminal 2"
                : exam_name === "unit-test-3"
                ? "Unit Test 3"
                : "Terminal 3"}
            </h5>
          </div>
          <div className="table-responsive mt-4">
            {students.length === 0 ? (
              <p>No students found for this class.</p>
            ) : (
              <table className="table table-striped table-hover table-bordered text-center">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Student Name</th>
                    <th>Student ID</th>
                    <th>Class Roll No.</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => (
                    <tr key={student.student_id}>
                      <td>{index + 1}</td>
                      <td>{student.student_name}</td>
                      <td>{student.student_id}</td>
                      <td>{student.class_roll_number}</td>
                      <td style={{ width: "30rem" }}>
                        <Link
                          to={`/erp/examinations/${exam_name}/class/${class_number}/${student.student_id}/update`}
                        >
                          <button className="btn btn-success btn-sm mx-3 actions-update">
                            Update Marks
                          </button>
                        </Link>
                        <Link
                          to={`/erp/examinations/${exam_name}/class/${class_number}/${student.student_id}/view`}
                        >
                          <button className="btn btn-primary btn-sm">
                            View Marks
                          </button>
                        </Link>
                        {exam_name.startsWith("term") && (
                          <Link
                            to={`/erp/marksheet/print/${student.student_id}/${exam_name}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <button className="btn btn-info btn-sm ms-3">
                              Generate Marksheet
                            </button>
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <ToastContainer /> {/* To render the toast notifications */}
    </>
  );
};

export default ExaminationStudentList;
